// compares two objects, a is the original, b is the one we compare to the original
// the function returns with true if the objects are the same,
// and returns with flase if they do not match
export const deepCompareObjects = <T>(a: T, b: T): boolean => {
    // testing if the type of object is an array
    if (Array.isArray(a) || Array.isArray(b)) {
        // if array length is not equal, the object is different than the other
        if ((a as unknown[]).length !== (b as unknown[]).length) return false;

        // we compare every array element to the other
        return (a as unknown[]).every((element, index) =>
            deepCompareObjects(element, b?.[index])
        );
    }

    // we test if the type of the object is not object or null
    if (
        typeof a !== 'object' ||
        typeof b !== 'object' ||
        (a === null && b === null)
    ) {
        // if they are primitive values or null, we compare them to each other
        return a === b;
    }

    // if the element is an object, we loop trough every keys and compare them one by one
    for (const key of Object.keys(a)) {
        if (deepCompareObjects(a[key], b[key])) continue;
        return false;
    }

    return true;
};
